import { render, staticRenderFns } from "./myAppointmentDetail.vue?vue&type=template&id=65c6dc22&scoped=true"
import script from "./myAppointmentDetail.vue?vue&type=script&lang=js"
export * from "./myAppointmentDetail.vue?vue&type=script&lang=js"
import style0 from "./myAppointmentDetail.vue?vue&type=style&index=0&id=65c6dc22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6dc22",
  null
  
)

export default component.exports